<div class="inline-form-wrapper">
  <div class="inline-form-scroll">
    <form (submit)="$event.preventDefault(); handleSubmit($event)">
      <dx-form id="form" #companyForm [(formData)]="formData">
        <dxi-item itemType="group" i18n-caption="@@companyData" caption="Company Data" [colCount]="2">
          <dxi-item dataField="name" isRequired="true">
            <dxo-label i18n-text="@@name" text="Name"></dxo-label>
            <div *dxTemplate="'nameTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.name"></dx-text-box>
            </div>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" i18n-caption="@@address" caption="Address" [colCount]="2">
          <dxi-item dataField="address" [editorOptions]="{ maxLength: 50 }">
            <dxo-label i18n-text="@@address" text="Address"></dxo-label>
            <div *dxTemplate="'addressTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.address"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="zipcode" [editorOptions]="{ maxLength: 50 }">
            <dxo-label i18n-text="@@zipcode" text="Zipcode"></dxo-label>
            <div *dxTemplate="'zipcodeTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.zipcode"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item dataField="city" [editorOptions]="{ maxLength: 50 }">
            <dxo-label i18n-text="@@city" text="City"></dxo-label>
            <div *dxTemplate="'cityTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.city"></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item [colSpan]="1" template="statesTemplate">
            <dxo-label i18n-text="@@country" text="Country"></dxo-label>
            <div *dxTemplate="let data of 'statesTemplate'">
              <dx-select-box
                class="gpd-input"
                [readOnly]="false"
                [(value)]="formData.countryId"
                [dataSource]="countriesByLanguageList"
                (onSelectionChanged)="handleCountryChange(formData.countryId)"
                displayExpr="countryName"
                valueExpr="countryId"
                acceptCustomValue="false">
              </dx-select-box>
            </div>
          </dxi-item>
          <dxi-item dataField="addition" [editorOptions]="{ maxLength: 50 }">
            <dxo-label i18n-text="@@addition" text="Addition"></dxo-label>
            <div *dxTemplate="'additionTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.addition"></dx-text-box>
            </div>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" i18n-caption="@@contactCaps" caption="Contact" [colCount]="2">
          <dxi-item dataField="phone" [editorOptions]="{ maxLength: 50 }">
            <dxo-label i18n-text="@@phone" text="Phone"></dxo-label>
            <div *dxTemplate="'phoneTemplate'">
              <dx-text-box class="gpd-input" [(value)]="formData.phone"></dx-text-box>
            </div>
          </dxi-item>
        </dxi-item>

      </dx-form>
    </form>

    <!-- Extension point for a caller-supplied Role picker — project-new-contact-modal and
         contacts-popup each project their own <gpd-role-select> here so it lands between
         Contact and Tags, matching the target design order. Not part of this component
         itself: the two callers need different validation behavior (one required and
         blocking Save, one optional/best-effort), so each owns its own role state instead
         of this component exposing a one-size-fits-all @Input for it. -->
    <ng-content></ng-content>

    <!-- Outside the dx-form on purpose: dx-form's group-caption divider is the top border of
         its .dx-form-group-content, sized to that content's own measured width — which
         DevExtreme gets right for its own widgets in a dxi-item but not reliably otherwise.
         Plain full-width div keeps Tags the same width as any projected Role block above it. -->
    <div class="inline-form-tags">
      <label class="inline-form-tags__label" i18n="@@tags">Tags</label>
      <div class="inline-form-tags__divider"></div>
      <dx-tag-box
        class="gpd-input"
        [items]="contactTags"
        displayExpr="title"
        valueExpr="id"
        [showSelectionControls]="true"
        applyValueMode="useButtons"
        [(value)]="formData.tags"
        i18n-placeholder="@@select"
        placeholder="Select"
        [inputAttr]="{ 'aria-label': 'Tags' }">
      </dx-tag-box>
    </div>
  </div>

</div>

<dx-toast [visible]="toastVisible" [type]="type" message="{{ message }}" position="bottom center" width="fit-content">
</dx-toast>
